import Dashboard from '@/common/components/layout/Dashboard';
import { ToastProvider } from '@/common/components/ui/toast/toast.provider';
import TableExternalServices from "./component/tables/TableExternalServices";
import Toast from '@/common/components/ui/toast';

export default function ExternalServicesRegister() {
    return (
        <ToastProvider>
            <Dashboard>
                <TableExternalServices />
            </Dashboard>
            <Toast />
        </ToastProvider>
    )
}
